module.exports = __webpack_public_path__ + "static/media/fashionforhome.1285bbd3.svg";